(function(){
  "use strict";
  if (window.__cqInited) return; window.__cqInited = true;
  var ROOT = document;
  if (!ROOT) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var q = function(sel){ return ROOT.querySelector(sel); };
  var qa = function(sel){ return ROOT.querySelectorAll(sel); };

  var WHATSAPP = "";
  var DELIVERY_FEE = 3;

  /* nav scroll */
  var nav = q('[data-cq="nav"]');
  var onScroll = function(){ nav.classList.toggle("cq-scrolled", window.scrollY > 30); };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive:true });

  /* scroll reveal */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("cq-in"); io.unobserve(e.target); } });
  }, { threshold:.16, rootMargin:"0px 0px -8% 0px" });
  qa(".cq-reveal,.cq-pop-in").forEach(function(el){ io.observe(el); });

  /* mostarda */
  var mustard = q('[data-cq="mustard-anim"]');
  if (mustard){
    var mio = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("cq-in"); mio.unobserve(e.target); } });
    }, { threshold:0.66 });
    mio.observe(mustard);
  }

  /* drawer */
  var drawer = q('[data-cq="drawer"]');
  var overlay = q('[data-cq="overlay"]');
  var openDrawer = function(){ drawer.classList.add("cq-open"); overlay.classList.add("cq-show"); };
  var closeDrawer = function(){ drawer.classList.remove("cq-open"); overlay.classList.remove("cq-show"); };
  q('[data-cq="burger"]').addEventListener("click", openDrawer);
  q('[data-cq="drawer-close"]').addEventListener("click", closeDrawer);
  qa(".cq-dlink").forEach(function(a){ a.addEventListener("click", closeDrawer); });

  /* ===== Carrinho Shopify (AJAX Cart API) ===== */
  var sidecart = q('[data-cq="sidecart"]');
  var openCart = function(){ sidecart.classList.add("cq-open"); overlay.classList.add("cq-show"); };
  var closeCart = function(){ sidecart.classList.remove("cq-open"); overlay.classList.remove("cq-show"); };
  q('[data-cq="cart-icon"]').addEventListener("click", function(){ refreshCart(); openCart(); });
  q('[data-cq="close-cart"]').addEventListener("click", closeCart);
  overlay.addEventListener("click", function(){ closeCart(); closeDrawer(); closeCheckout(); });

  var money = function(cents){ return (cents/100).toFixed(2).replace(".", ",") + "€"; };
  var UNITS_PER_PACK = (window.CQ_UNITS || 12);
  var cartData = { items: [], item_count: 0, total_price: 0 };
  var qtyById = {};
  var isCart = function(c){ return c && Object.prototype.toString.call(c.items) === "[object Array]"; };
  var chain = Promise.resolve();   // fila para serializar pedidos ao carrinho

  var toastEl = q('[data-cq="toast"]'); var toastTimer = null;
  function toast(msg){
    if (!toastEl || !msg) return;
    toastEl.textContent = msg;
    toastEl.classList.add("cq-show");
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toastEl.classList.remove("cq-show"); }, 2800);
  }
  function errMsg(res){ return (res.data && (res.data.description || res.data.message)) || "Sem stock disponível de momento."; }

  /* POST serializado: nunca rejeita — devolve sempre { ok, status, data } */
  function postCart(url, body){
    chain = chain.then(function(){
      return fetch(url, {
        method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify(body)
      }).then(function(r){
        return r.json().then(function(d){ return { ok:r.ok, status:r.status, data:d }; },
                             function(){ return { ok:r.ok, status:r.status, data:null }; });
      }).catch(function(){ return { ok:false, status:0, data:null }; });
    });
    return chain;
  }

  var vId = function(it){ return String(it.variant_id != null ? it.variant_id : it.id); };
  function indexCart(){ qtyById = {}; (cartData.items||[]).forEach(function(it){ qtyById[vId(it)] = it.quantity; }); }
  function recomputeTotals(){
    var items = cartData.items || [], cnt = 0, tot = 0;
    items.forEach(function(it){ cnt += it.quantity; tot += (it.final_line_price != null ? it.final_line_price : (it.final_price||0)*it.quantity); });
    cartData.item_count = cnt; cartData.total_price = tot;
  }
  function findByKey(key){ var it=cartData.items||[]; for(var i=0;i<it.length;i++){ if(it[i].key===key) return it[i]; } return null; }
  function findByVariant(id){ var it=cartData.items||[]; for(var i=0;i<it.length;i++){ if(vId(it[i])===String(id)) return it[i]; } return null; }

  function parseTiers(str){
    if (!str) return [];
    return str.split(';').map(function(s){
      var parts = s.split(':');
      if (parts.length < 2) return null;
      var u = parseInt((parts[0]||'').replace(/[^0-9]/g,''), 10);
      var p = parseFloat((parts[1]||'').replace(',', '.').replace(/[^0-9.]/g,''));
      if (!u || isNaN(p)) return null;
      return { minUnits: u, unitPrice: Math.round(p * 100) };
    }).filter(function(t){ return t; }).sort(function(a,b){ return a.minUnits - b.minUnits; });
  }
  function updateSave(id){
    var prodEl = q('[data-cq="prod"][data-variant-id="'+id+'"]');
    var saveEl = q('[data-cq="save"][data-variant-id="'+id+'"]');
    if (!prodEl || !saveEl) return;
    var units = parseInt(prodEl.getAttribute('data-units'),10) || 1;
    var baseUnit = parseInt(prodEl.getAttribute('data-unit-price'),10) || 0;
    var tiers = parseTiers(prodEl.getAttribute('data-tiers'));
    var packs = qtyById[id] || 0;
    var totalUnits = packs * units;
    var applied = null;
    for (var i=0;i<tiers.length;i++){ if (totalUnits >= tiers[i].minUnits) applied = tiers[i]; }
    if (applied && baseUnit > 0 && applied.unitPrice < baseUnit){
      var saved = (baseUnit - applied.unitPrice) * totalUnits;
      saveEl.textContent = 'Estás a poupar ' + money(saved);
      saveEl.removeAttribute('hidden');
    } else {
      saveEl.setAttribute('hidden','');
      saveEl.textContent = '';
    }
  }
  function syncSteppers(){
    qa('[data-qty-for]').forEach(function(el){
      var id = el.getAttribute('data-qty-for');
      var n = qtyById[id] || 0;
      var units = parseInt(el.getAttribute('data-units'),10) || 1;
      el.textContent = n * units;
      el.classList.toggle('cq-active', n > 0);
      updateSave(id);
    });
  }

  function paintCart(){
    var box = q('[data-cq="cart-items"]');
    if (!cartData.items || cartData.items.length === 0){
      box.innerHTML = '<p class="cq-cart-empty">O carrinho está vazio.<br>Escolhe uns croquetes 😋</p>';
    } else {
      box.innerHTML = cartData.items.map(function(it){
        var lineTotal = (it.final_line_price != null) ? it.final_line_price : (it.final_price || 0) * it.quantity;
        var unitsTxt=((window.CQ_MOLHO_IDS||[]).indexOf(it.product_id)>-1)?"":(UNITS_PER_PACK ? ((it.quantity * UNITS_PER_PACK) + ' unidades · ') : '');
        return '<div class="cq-cart-item">'
          + '<div class="cq-ci-info"><div class="cq-ci-name">'+it.product_title+'</div><div class="cq-ci-price">'+unitsTxt+money(lineTotal)+'</div></div>'
          + '<div class="cq-ci-qty">'
          + '<button data-act="dec" data-key="'+it.key+'" aria-label="Menos">−</button>'
          + '<span>'+it.quantity+'</span>'
          + '<button data-act="inc" data-key="'+it.key+'" aria-label="Mais">+</button>'
          + '</div></div>';
      }).join("");
    }
    q('[data-cq="cart-total"]').innerText = money(cartData.total_price || 0);
    q('[data-cq="cart-count"]').innerText = cartData.item_count || 0;
    box.querySelectorAll("button[data-act]").forEach(function(b){
      b.addEventListener("click", function(){
        var line = findByKey(b.dataset.key);
        if (!line) return;
        var nq = b.dataset.act === "inc" ? line.quantity+1 : line.quantity-1;
        setLineQty(line.key, Math.max(0, nq));
      });
    });
  }

  function applyCart(c){ if (!isCart(c)) return; cartData = c; indexCart(); paintCart(); syncSteppers(); }

  function refreshCart(){
    return fetch("/cart.js", { headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(c){ applyCart(c); return c; })
      .catch(function(){});
  }

  /* Define uma quantidade absoluta para uma linha (otimista + reconcilia) */
  function setLineQty(key, qty){
    var line = findByKey(key);
    if (line){
      if (qty <= 0){ cartData.items = cartData.items.filter(function(x){ return x.key !== key; }); }
      else { line.quantity = qty; line.final_line_price = (line.final_price||0) * qty; }
      recomputeTotals(); indexCart(); paintCart(); syncSteppers();
    }
    postCart("/cart/change.js", { id:key, quantity:Math.max(0,qty) }).then(function(res){
      if (res.ok && isCart(res.data)){ applyCart(res.data); }
      else { toast(errMsg(res)); refreshCart(); }
    });
  }

  /* +1 de uma variante (otimista: número e badge mexem já) */
  function addOne(id){
    qtyById[id] = (qtyById[id]||0) + 1;
    var el = q('[data-qty-for="'+id+'"]'); if (el){ var u=parseInt(el.getAttribute('data-units'),10)||1; el.textContent = qtyById[id]*u; el.classList.add('cq-active'); } updateSave(id);
    cartData.item_count = (cartData.item_count||0) + 1;
    q('[data-cq="cart-count"]').innerText = cartData.item_count;
    postCart("/cart/add.js", { items:[{ id:id, quantity:1 }] }).then(function(res){
      if (res.ok && res.data && res.data.items && res.data.items.length){
        var added = res.data.items[0], line = findByKey(added.key);
        if (line){ Object.keys(added).forEach(function(k){ line[k] = added[k]; }); }
        else { cartData.items = cartData.items || []; cartData.items.push(added); }
        recomputeTotals(); indexCart(); paintCart(); syncSteppers();
      } else { toast(errMsg(res)); refreshCart(); }
    });
  }
  function decOne(id){
    var line = findByVariant(id);
    if (!line) { refreshCart(); return; }
    setLineQty(line.key, line.quantity - 1);
  }

  /* steppers do menu */
  qa('[data-cq="step"]').forEach(function(btn){
    btn.addEventListener("click", function(){
      if (btn.disabled) return;
      var id = btn.getAttribute("data-variant-id");
      if (btn.getAttribute("data-act") === "inc") addOne(id); else decOne(id);
    });
  });

  /* tabs Feitos na hora / Congelados */
  var tabEls = qa('[data-cq="tab"]');
  var panelEls = qa('[data-cq="panel"]');
  var pill = q('[data-cq="tab-pill"]');
  function movePill(t){ if (pill && t){ pill.style.width = t.offsetWidth + "px"; pill.style.transform = "translateX(" + t.offsetLeft + "px)"; } }
  tabEls.forEach(function(t){
    t.addEventListener("click", function(){
      var name = t.dataset.tab;
      tabEls.forEach(function(x){ var on = x === t; x.classList.toggle("cq-tab-on", on); x.setAttribute("aria-selected", on ? "true" : "false"); });
      panelEls.forEach(function(p){ p.classList.toggle("cq-tab-on", p.dataset.panel === name); });
      movePill(t);
    });
  });
  var activeTab = q('[data-cq="tab"].cq-tab-on') || tabEls[0];
  if (activeTab){ requestAnimationFrame(function(){ movePill(activeTab); }); }
  window.addEventListener("resize", function(){ var a = q('[data-cq="tab"].cq-tab-on'); if (a) movePill(a); }, { passive:true });

  refreshCart();

  /* ===== Entrega / Recolha + checkout Shopify ===== */
  var checkout = q('[data-cq="checkout"]');
  var coDays = q('[data-cq="co-days"]');
  var coTimes = q('[data-cq="co-times"]');
  var coSummary = q('[data-cq="co-summary"]');
  var coConfirm = q('[data-cq="co-confirm"]');
  var coMethodBtns = qa('[data-cq="co-method"]');
  var pickupInfo = q('[data-cq="pickup-info"]');
  var CONFIRM_LABEL = (coConfirm.textContent || "Continuar para o checkout →").trim();
  var pickupAddrEl = q('[data-cq="pickup-addr"]');
  var freshNotice = q('[data-cq="fresh-notice"]');
  var timeBlock = q('[data-cq="time-block"]');
  var delivNote = q('[data-cq="delivery-window-note"]');
  var dayLabel = q('[data-cq="day-label"]');
  var timeLabel = q('[data-cq="time-label"]');
  var method = "delivery";
  var DELIVERY_DOWS = [1, 3, 5];   // Seg, Qua, Sex — únicos dias de entrega em casa
  var SAME_DAY_CUTOFF_HOUR = 12;   // encomenda para o próprio dia só até às 12h

  /* "Feitos na hora" = só recolha. Se houver algum no carrinho, força recolha. */
  var FRESH_IDS = (window.CQ_FRESH_IDS || []).map(String);
  function cartHasFresh(){
    return (cartData.items || []).some(function(it){ return FRESH_IDS.indexOf(vId(it)) !== -1; });
  }
  var WD = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
  var MO = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
  /* Recolha: slots de 15 min gerados entre o horário mais cedo e mais tarde de CQ_TIMES */
  function pad2(n){ return (n < 10 ? "0" : "") + n; }
  function hmLabel(mins){ return pad2(Math.floor(mins/60)) + "h" + pad2(mins % 60); }
  function buildPickupSlots(){
    var raw = (window.CQ_TIMES && window.CQ_TIMES.length) ? window.CQ_TIMES : ["19:00","21:30"];
    var mins = raw.map(function(s){ var p = String(s).split(":"); return parseInt(p[0],10)*60 + parseInt(p[1]||0,10); }).filter(function(n){ return !isNaN(n); });
    if (!mins.length) return [];
    var start = Math.min.apply(null, mins), end = Math.max.apply(null, mins);
    var slots = [];
    for (var m = start; m + 15 <= end; m += 15){ slots.push(hmLabel(m) + " - " + hmLabel(m + 15)); }
    return slots;
  }
  var selDay = null, selTime = null;

  var openCheckout = function(){ checkout.classList.add("cq-open"); overlay.classList.add("cq-show"); };
  var closeCheckout = function(){ checkout.classList.remove("cq-open"); overlay.classList.remove("cq-show"); };

  function setMethod(m){
    if (m === "delivery" && cartHasFresh()){ m = "pickup"; }   // feitos na hora nunca entregam
    method = m;
    coMethodBtns.forEach(function(b){ b.classList.toggle("cq-sel", b.getAttribute("data-method") === m); });
    var isPickup = (m === "pickup");
    if (pickupInfo) pickupInfo.style.display = isPickup ? "block" : "none";
    if (dayLabel) dayLabel.textContent = isPickup ? "Dia de recolha" : "Dia de entrega";
    if (timeLabel) timeLabel.textContent = "Hora de recolha";
    if (timeBlock) timeBlock.style.display = isPickup ? "block" : "none";   // hora só na recolha
    if (delivNote) delivNote.style.display = isPickup ? "none" : "block";   // aviso da janela de entrega só na entrega
    renderSchedule(); renderSummary(); validate();
  }
  coMethodBtns.forEach(function(b){ b.addEventListener("click", function(){ if (b.disabled) return; setMethod(b.getAttribute("data-method")); }); });

  /* Bloqueia a entrega e mostra o aviso quando há feitos na hora no carrinho */
  function updateFreshLock(){
    var locked = cartHasFresh();
    if (freshNotice) freshNotice.style.display = locked ? "block" : "none";
    coMethodBtns.forEach(function(b){
      if (b.getAttribute("data-method") === "delivery"){
        b.disabled = locked;
        b.classList.toggle("cq-disabled", locked);
      }
    });
    if (locked){ setMethod("pickup"); }
    return locked;
  }

  /* Entrega: só Seg/Qua/Sex; hoje só até às 12h. Recolha: amanhã em diante, sem domingos. */
  function buildDays(){
    var out = [];
    var today = new Date(); today.setHours(0,0,0,0);
    var now = new Date();
    if (method === "delivery"){
      for (var i = 0; i < 21 && out.length < 8; i++){
        var c = new Date(today); c.setDate(today.getDate() + i);
        if (DELIVERY_DOWS.indexOf(c.getDay()) === -1) continue;                 // só Seg/Qua/Sex
        if (i === 0 && now.getHours() >= SAME_DAY_CUTOFF_HOUR) continue;        // hoje já passou o limite das 12h
        out.push(c);
      }
      return out;
    }
    var d = new Date(today); d.setDate(d.getDate() + 1);
    while (out.length < 10){ if (d.getDay() !== 0) out.push(new Date(d)); d.setDate(d.getDate() + 1); }
    return out;
  }
  function renderSchedule(){
    selDay = null; selTime = null;
    var days = buildDays();
    coDays.innerHTML = days.length ? days.map(function(dt){
      var label = WD[dt.getDay()] + ", " + dt.getDate() + " " + MO[dt.getMonth()];
      return '<button type="button" class="cq-co-day" data-label="'+label+'"><span class="cq-wd">'+WD[dt.getDay()]+'</span><span class="cq-dn">'+dt.getDate()+'</span><span class="cq-mo">'+MO[dt.getMonth()]+'</span></button>';
    }).join("") : '<p class="cq-co-empty">Sem dias disponíveis de momento.</p>';
    coDays.querySelectorAll(".cq-co-day").forEach(function(b){
      b.addEventListener("click", function(){
        var wasSel = b.classList.contains("cq-sel");
        coDays.querySelectorAll(".cq-co-day").forEach(function(x){ x.classList.remove("cq-sel"); });
        if (wasSel){ selDay = null; } else { b.classList.add("cq-sel"); selDay = b.dataset.label; }
        validate();
      });
    });
    if (method === "pickup"){
      coTimes.innerHTML = buildPickupSlots().map(function(t){ return '<button type="button" class="cq-co-time">'+t+'</button>'; }).join("");
      coTimes.querySelectorAll(".cq-co-time").forEach(function(b){
        b.addEventListener("click", function(){
          var wasSel = b.classList.contains("cq-sel");
          coTimes.querySelectorAll(".cq-co-time").forEach(function(x){ x.classList.remove("cq-sel"); });
          if (wasSel){ selTime = null; } else { b.classList.add("cq-sel"); selTime = b.textContent; }
        });
      });
    } else {
      coTimes.innerHTML = "";
    }
  }
  function renderSummary(){
    var tail = (method === "pickup") ? "" : " + portes";
    coSummary.innerHTML =
      '<div class="cq-co-sr"><span>Subtotal ('+cartData.item_count+' art.)</span><span>'+money(cartData.total_price)+'</span></div>'
      + '<div class="cq-co-sr cq-tot"><span>A pagar no checkout</span><span>'+money(cartData.total_price)+tail+'</span></div>';
  }

  function validate(){
    var ok = !!selDay;                                   // basta escolher um dia
    coConfirm.disabled = !ok;
    coConfirm.textContent = ok ? CONFIRM_LABEL : "Escolhe um dia primeiro";
    return ok;
  }
  setMethod("delivery");

  q('[data-cq="checkout-btn"]').addEventListener("click", function(){
    if (!cartData.items || cartData.items.length === 0){ alert("Adiciona uns croquetes ao carrinho primeiro!"); return; }
    var locked = updateFreshLock();          // recolha forçada se houver feitos na hora (já renderiza)
    if (!locked){ setMethod("delivery"); }   // caso contrário, entrega por defeito (já renderiza)
    renderSummary(); validate();
    closeCart(); openCheckout();
  });
  q('[data-cq="checkout-close"]').addEventListener("click", closeCheckout);

  coConfirm.addEventListener("click", function(){
    if (!cartData.items || cartData.items.length === 0){ closeCheckout(); return; }
    if (!selDay){ validate(); if (coDays) coDays.scrollIntoView({ behavior:"smooth", block:"center" }); return; }
    coConfirm.disabled = true; coConfirm.textContent = "A abrir checkout…";

    var isPickup = (method === "pickup");
    var methodLabel = isPickup ? "Recolha" : "Entrega em casa";
    var pickupAddr = pickupAddrEl ? pickupAddrEl.textContent.trim() : "";
    var whenWord = isPickup ? "Recolha" : "Entrega";
    var noteLines = ["— PREFERÊNCIA CROQUÊ —", "Método: " + methodLabel];
    if (isPickup){ noteLines.push("Local de recolha: " + pickupAddr); }
    noteLines.push(whenWord + " preferida: " + selDay + (selTime ? " às " + selTime : (isPickup ? "" : " (entre 19h e 21h30)")));
    var note = noteLines.join("\n");

    var payload = {
      note: note,
      attributes: {
        "Método": methodLabel,
        "Local de recolha": isPickup ? pickupAddr : "",
        "Dia": selDay || "",
        "Hora": selTime || ""
      }
    };
    fetch("/cart/update.js", {
      method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify(payload)
    }).then(function(){ window.location.href = "/checkout"; })
      .catch(function(){ window.location.href = "/checkout"; });
  });

  /* croquete crossfade — começa SEMPRE fechado; só abre/fecha ao clicar (ou Enter/Espaço) */
  var stage = q('[data-cq="stage"]');
  var hint = q('[data-cq="hint"]');
  if (stage){
    var toggleStage = function(){
      var open = stage.classList.toggle("cq-open");
      if (hint) hint.style.opacity = open ? ".25" : ".85";
    };
    stage.addEventListener("click", toggleStage);
    stage.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " "){ e.preventDefault(); toggleStage(); } });
  }

  /* parallax hero */
  if (!reduce && window.matchMedia("(hover:hover)").matches){
    var hc = q('[data-cq="hero-croq"]');
    if (hc){
      window.addEventListener("mousemove", function(e){
        if (getComputedStyle(hc).display === "none") return;
        var px = (e.clientX / window.innerWidth - .5);
        var py = (e.clientY / window.innerHeight - .5);
        hc.style.transform = "translate(" + (px*18) + "px, " + (py*14) + "px)";
      }, { passive:true });
    }
  }

  /* bolinhas parallax */
  if (!reduce){
    var bolas = Array.prototype.slice.call(qa(".cq-bolinha[data-par]"));
    var bt = null;
    var moveBolas = function(){
      var vh = window.innerHeight || document.documentElement.clientHeight;
      bolas.forEach(function(b){
        var k = parseFloat(b.dataset.par) || .4;
        var r = b.parentElement.getBoundingClientRect();
        var center = (r.top + r.height/2) - vh/2;
        var par = -center * k * 0.06;
        if (par > 40) par = 40; else if (par < -40) par = -40;
        b.style.setProperty("--par", par.toFixed(1) + "px");
      });
      bt = null;
    };
    window.addEventListener("scroll", function(){ if (!bt) bt = requestAnimationFrame(moveBolas); }, { passive:true });
    window.addEventListener("resize", function(){ if (!bt) bt = requestAnimationFrame(moveBolas); }, { passive:true });
    moveBolas();
  }
})();
